<template>
  <el-container class="home-container">
    <!-- 头部区域 -->
    <el-header>
      <div>
        <img class="logo" src="../assets/logo.png"  alt="" />
        <span>誉享学后台管理系统</span>
      </div>
      <div class="userInfo">登陆账号：{{ phone }}</div>
       <div >
          <el-button type="info" @click="changePWD">修改密码</el-button>
        <el-button type="info" @click="logout">退出登录</el-button>
       </div>
       
    </el-header>
    <!-- 页面主体区域 -->
    <el-container>
      <!-- 侧边栏 -->
      <el-aside :width="isCollapse ? '64px' : '200px'">
        <div class="toggle-button" @click="toggleCollapse">|||</div>
        <!-- 侧边栏菜单区域 -->
        <el-menu background-color="#333744" text-color="#fff" active-text-color="#409EFF" unique-opened :collapse="isCollapse" :collapse-transition="false" router :default-active="activePath">
          <!-- 一级菜单 -->
          <el-submenu :index="item.id + ''" v-for="item in menulist" :key="item.id">
            <!-- 一级菜单的模板区域 -->
            <template slot="title">
              <!-- 图标 -->
              <i :class="iconsObj[item.id]"></i>
              <!-- 文本 -->
              <span>{{ item.name }}</span>
            </template>

            <!-- 二级菜单 -->
            <el-menu-item :index="'/' + subItem.path" v-for="subItem in item.children" :key="subItem.id" @click="saveNavState('/' + subItem.path)">
              <template slot="title">
                <!-- 图标 -->
                <i class="el-icon-menu"></i>
                <!-- 文本 -->
                <span>{{ subItem.name }}</span>
              </template>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <!-- 右侧内容主体 -->
      <el-main>
        <!-- 路由占位符 -->
        <router-view></router-view>
      </el-main>
    </el-container>
      <!-- 修改用户自己密码的对话框 -->
    <el-dialog title="修改我的密码" :visible.sync="changeMyPwdDialogVisible" width="50%" @close="changeMyPwdDialogClosed">
      <el-form :model="changeMyPwdForm" :rules="changeMyPwdFormRules" ref="changeMyPwdFormRef" label-width="130px">
        <el-form-item label="原始密码" prop="password">
          <el-input v-model="changeMyPwdForm.password"></el-input>
        </el-form-item>

        <el-form-item label="新密码" prop="newPwd">
          <el-input v-model="changeMyPwdForm.newPwd"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="changeMyPwdDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="changeMyPwdSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>

  

</template>

<script>
export default {
  data () {
    return {
       // 添加用户的表单数据
      changeMyPwdDialogVisible: false,
      changeMyPwdForm: {
        password: '',
        newPwd: '',
      },

      changeMyPwdFormRules: {
        password: [
          { required: true, message: '请输入原密码', trigger: 'blur' },
          {
            min: 6,
            max: 15,
            message: '密码的长度在6~15个字符之间',
            trigger: 'blur',
          },
        ],
        newPwd: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          {
            min: 6,
            max: 15,
            message: '密码的长度在6~15个字符之间',
            trigger: 'blur',
          },
        ],
      },

      phone: null,
      // 左侧菜单数据
      menulist: [],
      twoMenulist: [],
      iconsObj: {
        '1': 'iconfont icon-user',
        '2': 'iconfont icon-tijikongjian',
        '3': 'iconfont icon-shangpin',
        '4': 'iconfont icon-danju',
        '5': 'iconfont icon-baobiao',
        '6': 'iconfont icon-baobiao',
        '7': 'iconfont icon-baobiao',
        '8': 'iconfont icon-baobiao',
        '9': 'iconfont icon-lock_fill',
      },
      // 是否折叠
      isCollapse: false,
      // 被激活的链接地址
      activePath: '',
      role: 0,//1管理员2经销商
    }
  },
  created () {
    this.activePath = window.sessionStorage.getItem('activePath')
    this.role = window.sessionStorage.getItem('role')
    this.getMenuList()
  },



  methods: {
     // 监听修改用户对话框的关闭事件
    changeMyPwdDialogClosed() {
      this.$refs.changeMyPwdFormRef.resetFields()
    },

    changePWD(){
        this.changeMyPwdDialogVisible = true
    },

      // 修改用户信息并提交
    changeMyPwdSubmit() {
      this.$refs.changeMyPwdFormRef.validate(async (valid) => {
        if (!valid) return
        // 发起修改用户信息的数据请求
        const { data: res } = await this.$http.post('admin/managed/changeMyPwd', this.changeMyPwdForm)
        if (res.code !== 200) {
          return this.$message.error('修改密码失败！')
        }

        // 关闭对话框
        this.changeMyPwdDialogVisible = false
        // 刷新数据列表
        // this.getUserList()
        // 提示修改成功
        this.$message.success('更新密码成功！')
      })
    },

    logout () {
      window.sessionStorage.clear()
      window.localStorage.clear()
      this.$router.push('/login')
    },

    // 获取所有的菜单
    async getMenuList () {
      this.phone = window.sessionStorage.getItem('phone');
      if (!this.phone) {
        window.sessionStorage.clear()
        this.$router.push('/login')
      }
      const { data: res } = await this.$http.post('admin/user/getUseruthority', {
        phone: this.phone,
        role: this.role
      })
      if (res.code !== 200) return this.$message.error(res.meta.msg)
      this.menulist = res.result

      var twolist = [];
      if (res.result) {
        res.result.forEach(ele => {
          ele.children.forEach(ele1 => {
            twolist.push(ele1)
          })
        })
        window.sessionStorage.setItem('twoMenulist', twolist);
      }
      this.twoMenulist = twolist
      var path = this.activePath;
      console.log(path);
      console.log('000000000---------99999999999');
      if (path && path.length > 0) {
        this.twoMenulist.forEach(ele => {
          // console.log(ele.path);
          if (ele.path == path.substring(1, path.length)) {
            window.sessionStorage.setItem('pathCanLook', ele.canLook)
          }
        })
      }
    },

    // 点击按钮，切换菜单的折叠与展开
    toggleCollapse () {
      this.isCollapse = !this.isCollapse
    },
    // 点击二级菜单，保存链接的激活状态
    saveNavState (activePath) {
      console.log(this.twoMenulist);
      window.sessionStorage.setItem('activePath', activePath)
      // console.log(activePath.substring(1, activePath.length));
      this.twoMenulist.forEach(ele => {
        // console.log(ele.canLook);
        if (ele.path == activePath.substring(1, activePath.length)) {
          window.sessionStorage.setItem('pathCanLook', ele.canLook)
        }
      })
      this.activePath = activePath
    }
  }
}
</script>

<style lang="less" scoped>
.home-container {
  height: 100%;
}
.logo {
  width: 200px;
  height: 120px;
}

.el-header {
  background-color: #373d41;
  display: flex;
  justify-content: space-between;
  padding-left: 0;
  align-items: center;
  color: #fff;
  font-size: 20px;
  > div {
    display: flex;
    align-items: center;
    span {
      margin-left: 15px;
    }
  }
}

.userInfo {
  font-size: 16px;
}

.el-aside {
  background-color: #333744;
  .el-menu {
    border-right: none;
  }
}

.el-main {
  background-color: #eaedf1;
}

.iconfont {
  margin-right: 10px;
}

.toggle-button {
  background-color: #4a5064;
  font-size: 10px;
  line-height: 24px;
  color: #fff;
  text-align: center;
  letter-spacing: 0.2em;
  cursor: pointer;
}
</style>
